import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Button, Dialog } from '@dsi/react-eds';
import styles from './SwgwScanning.module.css';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useLoader } from '../../../hooks/useLoader';
import api from '../../../api/axiosInstance';
import { useSwobNotifications } from '../../../hooks/NotificationsProvider';
import { AxiosError } from 'axios';

export interface DeleteProductNumberDialogProps {
  open: boolean;
  product: { sw_product_no: string; name: string } | null;
  onDelete: () => void;
  onCancel: () => void;
}

const DeleteProductNumberDialog: React.FC<DeleteProductNumberDialogProps> = ({ open, product, onDelete, onCancel }) => {
  useEffect(() => {
      if (open) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
      return () => {
        document.body.style.overflow = '';
      };
    }, [open]);

  const { addNotifications } = useSwobNotifications();
  const { showLoader, hideLoader } = useLoader();

  const deleteProduct = async () => {
    showLoader();
    try {
      await api.delete(`api/swgw-product`, {data:{ 'productNames': [product?.name] }});
      onDelete();
      addNotifications([
        {
          title: 'Success',
          icon: 'icon-success',
          description: `Product ${product?.sw_product_no} was successfully deleted.`,
          timestamp: new Date(),
          color: 'green',
        },
      ]);
    } catch (error: unknown) {
      let errorMsg = `An error occurred while deleting the product ${product?.sw_product_no}.`;
      if (error instanceof AxiosError) {
        errorMsg = error?.response?.data?.message || error?.message;
      }
      addNotifications([
        {
          title: 'Error',
          icon: 'icon-triangle-warning',
          description: errorMsg,
          timestamp: new Date(),
          color: 'red',
        },
      ]);
      onCancel();
    } finally {
      setTimeout(() => {
        hideLoader();
      }, 500);
    }
  };

  return ReactDOM.createPortal(
    <ReactEDSWrapper
      component={Dialog}
      show={open}
      onClose={onCancel}
      title="Remove Product Number"
      subtitle="SWGW Scanning"
      bottom={
        <ReactEDSWrapper
          component={Button}
          variant="primary"
          className="btn primary"
          type="button"
          onClick={deleteProduct}
        >
          Remove Product Number
        </ReactEDSWrapper>
      }
    >
      <div className={styles.whiteText}>
        You're about to remove this product {product?.sw_product_no} from the list.<br />
        This action is permanent and cannot be undone.<br /><br />
        Are you sure you want to continue?
      </div>
    </ReactEDSWrapper>, document.body
  );
};

export default DeleteProductNumberDialog;
